import { useState } from 'react'
import BackButton from '../components/BackButton.jsx'

const secoes = [
  { id: 'login', emoji: '🔐', titulo: 'Acessando o Sistema', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Faça login com seu nome de usuário ou e-mail e senha (mínimo 4 caracteres).</p>
      <h3 className="text-sm font-semibold mb-2">Como fazer login:</h3>
      <div className="space-y-1 mb-3">
        {['Digite seu login (nome ou e-mail)','Digite sua senha','Clique em "Entrar"'].map((s,i)=>(
          <div key={i} className="rounded-lg bg-blue-500/10 border-l-2 border-blue-400 px-3 py-2 text-xs text-white/80">{i+1}. {s}</div>
        ))}
      </div>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Esqueceu a senha? Clique em "Esqueci minha senha" e use a pergunta de segurança.</div>
    </>
  )},
  { id: 'dashboard', emoji: '📊', titulo: 'Dashboard', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">A Dashboard mostra um resumo geral do sistema com indicadores importantes.</p>
      <h3 className="text-sm font-semibold mb-2">Indicadores disponíveis:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li><strong>Total de produtos</strong> — itens cadastrados no estoque</li>
        <li><strong>Total de funcionários</strong> — funcionários ativos</li>
        <li><strong>Empréstimos pendentes</strong> — ferramentas/EPIs não devolvidos</li>
        <li><strong>Em manutenção</strong> — itens em manutenção</li>
        <li><strong>Abaixo do mínimo</strong> — itens com estoque abaixo do mínimo</li>
        <li><strong>Sem estoque</strong> — itens com quantidade zero</li>
        <li><strong>EPIs vencidos / prestes a vencer</strong></li>
      </ul>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Clique nos indicadores de EPIs para ver a lista completa.</div>
    </>
  )},
  { id: 'estoque', emoji: '📦', titulo: 'Gestão de Estoque', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Cadastre, edite e controle todos os materiais do almoxarifado.</p>
      <h3 className="text-sm font-semibold mb-2">Tipos de itens:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li><strong>Material</strong> — consumo definitivo</li>
        <li><strong>Ferramenta</strong> — empréstimo com devolução</li>
        <li><strong>EPI</strong> — pode ser reutilizável ou descartável</li>
      </ul>
      <h3 className="text-sm font-semibold mb-2">Cadastrar produto:</h3>
      <div className="space-y-1 mb-3">
        {['Acesse "Estoque" no menu','Clique no botão "+"','Preencha Nome, Quantidade, Estoque Mínimo','Campos opcionais: Código, Descrição, Custo, CA, Data de Validade, Foto','Clique em "Salvar"'].map((s,i)=>(
          <div key={i} className="rounded-lg bg-blue-500/10 border-l-2 border-blue-400 px-3 py-2 text-xs text-white/80">{i+1}. {s}</div>
        ))}
      </div>
      <div className="rounded-lg bg-amber-500/10 border-l-2 border-amber-400 px-3 py-2 text-xs text-white/80">⚠️ A exclusão é permanente e não pode ser desfeita.</div>
    </>
  )},
  { id: 'funcionarios', emoji: '👷', titulo: 'Gestão de Funcionários', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Gerencie funcionários na aba "Funcionários" do Estoque ou na página dedicada.</p>
      <h3 className="text-sm font-semibold mb-2">Cadastrar funcionário:</h3>
      <div className="space-y-1 mb-3">
        {['Acesse "Estoque" → aba "Funcionários" ou "Funcionários" no menu','Clique no botão "+"','Preencha: Nome, Matrícula (opcional), Função (opcional)','Clique em "Salvar"'].map((s,i)=>(
          <div key={i} className="rounded-lg bg-blue-500/10 border-l-2 border-blue-400 px-3 py-2 text-xs text-white/80">{i+1}. {s}</div>
        ))}
      </div>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Clique em "Histórico" ao lado do funcionário para ver todas as movimentações.</div>
    </>
  )},
  { id: 'entregas', emoji: '🚚', titulo: 'Entrega de Materiais', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Registre a entrega de materiais com controle individual por funcionário.</p>
      <div className="space-y-1 mb-3">
        {['Acesse "Entrega" no menu','Selecione o funcionário','Selecione o tipo de produto','Selecione o produto e informe a quantidade','Para EPIs: selecione o motivo (Novo, Perda ou Troca)','Adicione ao carrinho e repita se necessário','Assine digitalmente (opcional)','Clique em "Registrar Entrega"'].map((s,i)=>(
          <div key={i} className="rounded-lg bg-blue-500/10 border-l-2 border-blue-400 px-3 py-2 text-xs text-white/80">{i+1}. {s}</div>
        ))}
      </div>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Adicione vários itens ao carrinho antes de finalizar.</div>
    </>
  )},
  { id: 'pedidos', emoji: '📋', titulo: 'Pedidos de Material', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Crie pedidos para solicitar reposição de estoque.</p>
      <div className="space-y-1 mb-3">
        {['Acesse "Pedidos" no menu','Clique em "Novo Pedido"','Selecione produto e quantidade','Adicione ao carrinho','Clique em "Enviar para Compras"'].map((s,i)=>(
          <div key={i} className="rounded-lg bg-blue-500/10 border-l-2 border-blue-400 px-3 py-2 text-xs text-white/80">{i+1}. {s}</div>
        ))}
      </div>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Use o ícone PDF para exportar o pedido. Use o ícone WhatsApp para compartilhar.</div>
    </>
  )},
  { id: 'pendentes', emoji: '⏰', titulo: 'Pendentes e Manutenção', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Controla empréstimos não devolvidos e itens em manutenção.</p>
      <h3 className="text-sm font-semibold mb-2">Ações disponíveis:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li><strong>Registrar Devolução</strong> — marca o item como devolvido</li>
        <li><strong>Marcar como Perdido</strong> — registra a perda</li>
        <li><strong>Enviar para Manutenção</strong> — envia para manutenção</li>
        <li><strong>Retorno de Manutenção</strong> — marca como disponível novamente</li>
      </ul>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Use filtros para encontrar itens por funcionário ou dias de atraso.</div>
    </>
  )},
  { id: 'configuracoes', emoji: '⚙️', titulo: 'Configurações', conteudo: (
    <>
      <h3 className="text-sm font-semibold mb-2">Backup:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li>Criar backup manual a qualquer momento</li>
        <li>Restaurar backup de arquivo JSON</li>
        <li>Backup automático configurável (diário, semanal)</li>
      </ul>
      <h3 className="text-sm font-semibold mb-2">Administração:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li><strong>Gerenciar Usuários</strong> — criar, editar, trocar senha, desativar</li>
        <li><strong>Log de Auditoria</strong> — histórico de ações do sistema</li>
        <li><strong>Limpar Banco Local</strong> — apaga todos os dados (irreversível)</li>
      </ul>
      <div className="rounded-lg bg-amber-500/10 border-l-2 border-amber-400 px-3 py-2 text-xs text-white/80">⚠️ Faça backup antes de limpar o banco de dados.</div>
    </>
  )},
  { id: 'usuarios', emoji: '👤', titulo: 'Gerenciar Usuários', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Disponível apenas para administradores em Configurações → Gerenciar Usuários.</p>
      <div className="space-y-1 mb-3">
        {['Acesse "Configurações" → "Gerenciar Usuários"','Clique em "Criar usuário"','Preencha: Nome, Login, Senha (mín. 4 dígitos), Perfil, Pergunta de segurança','Clique em "Criar"'].map((s,i)=>(
          <div key={i} className="rounded-lg bg-blue-500/10 border-l-2 border-blue-400 px-3 py-2 text-xs text-white/80">{i+1}. {s}</div>
        ))}
      </div>
      <h3 className="text-sm font-semibold mb-2">Perfis:</h3>
      <ul className="space-y-1 text-xs text-white/70 list-disc list-inside">
        <li><strong>Admin</strong> — acesso total ao sistema</li>
        <li><strong>Operador</strong> — acesso às funções do dia a dia</li>
      </ul>
    </>
  )},
  { id: 'obras', emoji: '🏗️', titulo: 'Centro de Custo por Obra', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Gerencie obras e aloque consumo de materiais por projeto/cliente.</p>
      <h3 className="text-sm font-semibold mb-2">Cadastrar obra:</h3>
      <div className="space-y-1 mb-3">
        {['Acesse "Obras" no menu','Clique em "Nova Obra"','Preencha: Nome, Código, Cliente, Endereço','Defina status: Ativa, Finalizada ou Parada','Clique em "Salvar"'].map((s,i)=>{
          const bg = i === 0 ? 'bg-blue-500/10 border-blue-400' : 'bg-white/5 border-white/20'
          return <div key={i} className={`rounded-lg border-l-2 px-3 py-2 text-xs text-white/80 ${bg}`}>{i+1}. {s}</div>
        })}
      </div>
      <h3 className="text-sm font-semibold mb-2">Vincular em entregas:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li>Ao registrar uma entrega, selecione a obra no campo "Obra"</li>
        <li>Todas as saídas serão vinculadas à obra selecionada</li>
        <li>Veja o total gasto por obra na tela Financeiro</li>
      </ul>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Use os relatórios "Consumo por Obra" e "Custo Total por Obra" para análise detalhada.</div>
    </>
  )},
  { id: 'nfs', emoji: '📎', titulo: 'Notas Fiscais', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Vincule notas fiscais aos produtos para controle de origem e relatórios.</p>
      <h3 className="text-sm font-semibold mb-2">Cadastrar NF:</h3>
      <div className="space-y-1 mb-3">
        {['Acesse "Estoque" → aba "Notas Fiscais"','Clique em "Nova Nota Fiscal"','Preencha: Número, Série, Data Emissão, CNPJ Fornecedor, Valor Total','Clique em "Salvar"'].map((s,i)=>{
          const bg = i === 0 ? 'bg-blue-500/10 border-blue-400' : 'bg-white/5 border-white/20'
          return <div key={i} className={`rounded-lg border-l-2 px-3 py-2 text-xs text-white/80 ${bg}`}>{i+1}. {s}</div>
        })}
      </div>
      <h3 className="text-sm font-semibold mb-2">Vincular ao produto:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li>No cadastro/edição de produto, selecione a NF no campo "Nota Fiscal"</li>
        <li>O produto mostrará badge "📎 Nota Fiscal vinculada"</li>
        <li>Use o filtro "Possui NF" na tela de estoque</li>
      </ul>
      <h3 className="text-sm font-semibold mb-2">Buscar por NF:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li>Na tela Estoque, use o campo "Buscar por NF"</li>
        <li>Digite parte do número da nota fiscal</li>
        <li>O sistema filtra produtos vinculados àquela NF</li>
      </ul>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Consulte relatórios "Produtos por Nota Fiscal" e "Compras por Fornecedor".</div>
    </>
  )},
  { id: 'relatorios', emoji: '📊', titulo: 'Relatórios', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Gere 13 tipos de relatórios com filtros avançados e exportação.</p>
      <h3 className="text-sm font-semibold mb-2">Categorias de relatórios:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li><strong>Consumo:</strong> Por Funcionário, Por Produto, Por Obra, Custo Total por Obra</li>
        <li><strong>Segurança (EPI):</strong> Por Motivo, Vencidos, Prestes a Vencer</li>
        <li><strong>Operacional:</strong> Pendentes, Perdas, Inventário por Localização</li>
        <li><strong>Notas Fiscais:</strong> Produtos por NF, Compras por Fornecedor</li>
        <li><strong>Financeiro:</strong> Visão geral com KPIs e gastos por obra</li>
      </ul>
      <h3 className="text-sm font-semibold mb-2">Filtros disponíveis:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li>Período (data inicial/final)</li>
        <li>Funcionário específico</li>
        <li>Tipo de produto (Material/Ferramenta/EPI)</li>
        <li>Obra específica</li>
        <li>Possui NF (Sim/Não)</li>
        <li>Fornecedor (nome/CNPJ)</li>
      </ul>
      <h3 className="text-sm font-semibold mb-2">Exportar:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li><strong>PDF:</strong> Com cabeçalho, logo e tabelas formatadas</li>
        <li><strong>CSV:</strong> Para abrir no Excel</li>
      </ul>
      <div className="rounded-lg bg-emerald-500/10 border-l-2 border-emerald-400 px-3 py-2 text-xs text-white/80">💡 Use o período para filtrar dados específicos antes de exportar.</div>
    </>
  )},
  { id: 'financeiro', emoji: '💰', titulo: 'Módulo Financeiro', conteudo: (
    <>
      <p className="text-sm text-white/70 mb-3">Visão gerencial dos custos e investimentos (apenas admin).</p>
      <h3 className="text-sm font-semibold mb-2">KPIs disponíveis:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li><strong>Investimento:</strong> Total de entradas (compras)</li>
        <li><strong>Consumo:</strong> Materiais/EPIs consumidos</li>
        <li><strong>Prejuízo:</strong> Itens perdidos ou danificados</li>
        <li><strong>Manutenção:</strong> Custos com manutenção</li>
        <li><strong>Estoque atual:</strong> Valor do estoque em mãos</li>
        <li><strong>Gastos por Obra:</strong> Total consumido em cada obra</li>
      </ul>
      <h3 className="text-sm font-semibold mb-2">Classificação de movimentações:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li><strong>Consumo:</strong> Saída definitiva do material</li>
        <li><strong>Investimento:</strong> Entrada de novos produtos</li>
        <li><strong>Prejuízo:</strong> Perda ou dano irreversível</li>
        <li><strong>Manutenção:</strong> Reparo de ferramentas</li>
      </ul>
      <h3 className="text-sm font-semibold mb-2">Configuração:</h3>
      <ul className="space-y-1 mb-3 text-xs text-white/70 list-disc list-inside">
        <li>Ative/desative o módulo em Configurações → Financeiro</li>
        <li>Opção "Esconder Valores" oculta preços na interface</li>
      </ul>
      <div className="rounded-lg bg-amber-500/10 border-l-2 border-amber-400 px-3 py-2 text-xs text-white/80">⚠️ Apenas administradores têm acesso ao módulo financeiro.</div>
    </>
  )},
  { id: 'faq', emoji: '❓', titulo: 'Perguntas Frequentes', conteudo: (
    <>
      <div className="space-y-3">
        {[
          ['O sistema funciona offline?', 'Sim! Todos os dados são armazenados localmente no dispositivo. Não precisa de internet.'],
          ['Posso acessar pelo celular?', 'Sim, o sistema é responsivo. Em Configurações, clique em "Instalar App" para adicionar à tela inicial.'],
          ['Esqueci minha senha?', 'Na tela de login, clique em "Esqueci minha senha" e responda a pergunta de segurança cadastrada.'],
          ['Posso ter vários usuários?', 'Sim. O administrador pode criar múltiplos usuários em Configurações → Gerenciar Usuários.'],
          ['Como vincular uma obra à entrega?', 'Ao registrar entrega, selecione a obra no campo "Obra". Todas as saídas serão vinculadas a ela.'],
          ['Como cadastrar uma Nota Fiscal?', 'Acesse Estoque → Notas Fiscais, clique em "Nova" e preencha os dados. Depois vincule ao produto.'],
          ['Qual a diferença entre perfis?', 'Admin: acesso total. Almoxarife: operações diárias. Comprador: apenas compras e estoque.'],
        ].map(([q,a],i)=>(
          <div key={i} className="rounded-xl bg-white/5 p-3">
            <div className="text-sm font-medium mb-1">{q}</div>
            <div className="text-xs text-white/60">{a}</div>
          </div>
        ))}
      </div>
    </>
  )},
]

export default function ManualPage() {
  const [aberta, setAberta] = useState(null)

  return (
    <div className="space-y-4">
      <BackButton />

      <div className="rounded-2xl cm-card p-4">
        <div className="flex items-center gap-3">
          <img src="/logo.png" alt="logo" className="h-10 w-10 rounded-xl object-contain bg-white/10" />
          <div>
            <div className="text-sm font-bold">Manual de Uso</div>
            <div className="text-xs text-white/60">Caixa Mestre · Sistema de Gestão de Almoxarifado</div>
          </div>
        </div>
      </div>

      <div className="space-y-2">
        {secoes.map(s => (
          <div key={s.id} className="rounded-2xl cm-card overflow-hidden">
            <button
              onClick={() => setAberta(aberta === s.id ? null : s.id)}
              className="flex w-full items-center justify-between px-4 py-3 text-left"
            >
              <div className="flex items-center gap-2 text-sm font-semibold">
                <span>{s.emoji}</span><span>{s.titulo}</span>
              </div>
              <span className="text-white/40 text-xs">{aberta === s.id ? '▲' : '▼'}</span>
            </button>
            {aberta === s.id && (
              <div className="border-t border-white/10 px-4 pb-4 pt-3">
                {s.conteudo}
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="text-center text-xs text-white/30 pb-2">
        © 2026 Caixa Mestre · Sistema de Gestão de Almoxarifado
      </div>
    </div>
  )
}
